var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5023 22.0037H7.49772C6.96702 22.0037 6.45802 21.7931 6.08276 21.4178C5.7075 21.0426 5.49689 20.5336 5.49689 20.0029V5.99705C5.49689 5.46635 5.7075 4.95735 6.08276 4.58209C6.45802 4.20682 6.96702 3.99622 7.49772 3.99622H18.5023C19.033 3.99622 19.542 4.20682 19.9173 4.58209C20.2925 4.95735 20.5031 5.46635 20.5031 5.99705V20.0029C20.5031 20.5336 20.2925 21.0426 19.9173 21.4178C19.542 21.7931 19.033 22.0037 18.5023 22.0037Z",
    stroke: "#5A2FB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.041 6.87247C13.0079 6.87235 12.9761 6.88552 12.9528 6.90903C12.9295 6.93254 12.9166 6.96442 12.917 6.99752C12.917 7.04819 12.9475 7.09386 12.9944 7.11315C13.0413 7.13245 13.0951 7.12156 13.1308 7.08559C13.1665 7.04962 13.1769 6.99567 13.1573 6.94897C13.1376 6.90228 13.0917 6.87207 13.041 6.87247",
    stroke: "#5A2FB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99835 10.9991H17.0017",
    stroke: "#5A2FB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 17.0017H8.99835",
    stroke: "#5A2FB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99835 14.0005H17.0017",
    stroke: "#5A2FB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.6ef244c6.svg";
export { ForwardRef as ReactComponent };